import './style.css';
import { jsx as u } from "react/jsx-runtime";
import { c as d } from "../../__shared__/index.js";
const a = "_price_9ogxm_1", i = "_reduced_9ogxm_13", l = "_strikethrough_9ogxm_17", e = {
  price: a,
  default: "_default_9ogxm_9",
  reduced: i,
  strikethrough: l
}, t = {
  default: e.default,
  reduced: e.reduced,
  strikethrough: e.strikethrough
};
function h({
  formattedPrice: r,
  variant: c = "default",
  class: s
}) {
  const o = d(
    e.price,
    t[c] ?? t.default,
    s
  );
  return /* @__PURE__ */ u("span", { className: o, children: r });
}
export {
  h as default
};
//# sourceMappingURL=PriceLabel.js.map
